var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "full-width-modal",
      attrs: { shown: _vm.shown },
      on: { close: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "center-content-position" }, [
        _c("div", { staticClass: "modal-header no-padding-left" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-10 account-modal" }, [
              _c("h2", { staticClass: "modal-title " }, [
                _vm._v("Account Details"),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "username" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.user.name) +
                      "\n              "
                  ),
                  _vm.internal
                    ? _c("span", [_vm._v(" (" + _vm._s(_vm.internal) + ")")])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container account-modal-container" }, [
          _c("div", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass: "control-label col-xs-1",
                  attrs: { for: "name" },
                },
                [_vm._v("Name")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-5" }, [
                _c(
                  "span",
                  {
                    staticClass: "form-control",
                    attrs: { type: "text", id: "name" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.user.name) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass: "control-label col-xs-1",
                  attrs: { for: "userId" },
                },
                [_vm._v("User ID")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-5" }, [
                _c(
                  "span",
                  {
                    staticClass: "form-control",
                    attrs: { type: "text", id: "userId" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.user.userId) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center-content-position" }, [
        _c("div", { staticClass: "modal-footer" }, [
          _c("span", { staticClass: "app-version-number" }, [
            _vm._v("V " + _vm._s(_vm.version)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn btn-default", on: { click: _vm.handleClose } },
            [_vm._v("Close")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }